export class BaseError extends Error {
  
  getHttpStatus() {
    return this.httpStatus;
  }
  
}

export class PayloadError extends BaseError {
  
  constructor(httpStatus, httpMessage, data) {
    super();
    
    this.httpStatus = httpStatus;
    this.message = httpMessage;
    this.data = data;
    this.details = data.errors;
  }

}

export class ServerError extends BaseError {
  
  constructor(data) {
    super();
    
    this.httpStatus = null;
    this.data = data;
    this.message = data.message || 'Server Error';
    this.details = null;
  }
  
}

export class AppError extends BaseError {
  
  constructor(code, data) {
    super();
    
    this.httpStatus = null;
    this.code = code;
    this.data = data;
    this.message = errorCodes[code] || code;
    this.details = null;
  }
  
}

const errorCodes = {
  'json_error': 'An error occurred whilst processing this request.'
};
